module.exports = __webpack_public_path__ + "img/pager-button.4f5063a0.svg";